import { useTranslation } from "react-i18next";
import { Loading, InlineNotification } from "@carbon/react";
import { useSellerKpis } from "../../hooks/useSellerKpis";
import SellerKpiMetricCards from "../../components/KPIs/SellerKpiMetricCards/SellerKpiMetricCards";
import "./sellerAnalytics.scss";

/**
 * The seller KPI panel: `SellerKpiMetricCards` (unchanged, Task 4 — its exact card labels
 * "Number of Clients"/"Auctions Won"/"Auctions Participated"/"Closing Rate" are pinned by
 * `e2e/dashboards.spec.ts`'s seller test). Rebuilt on Carbon (Dashboards flow, Task 5) — same
 * `Loading`/`InlineNotification` convention as `ManagerDashboard.tsx`.
 */
const SellerAnalytics = () => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useSellerKpis();

  if (isLoading) {
    return (
      <div className="seller-analytics__loading">
        <Loading withOverlay={false} small description={t("cta.loading")} />
      </div>
    );
  }

  if (error) {
    return (
      <InlineNotification
        kind="error"
        lowContrast
        hideCloseButton
        title={t("analytics.errorTitle")}
        subtitle={t("analytics.errorMessage")}
      />
    );
  }

  if (!data) {
    return <p className="seller-analytics__empty">{t("analytics.noDataAvailable")}</p>;
  }

  return (
    <div className="seller-analytics">
      <SellerKpiMetricCards data={data} />
    </div>
  );
};

export default SellerAnalytics;
